<template>
    <v-main>
      <v-container class="containerText my-12 py-12">
        <v-layout text-center>
          <v-flex>
			<div class="mt-5 pa-1 text-left">
				<h2>Impressum</h2>

				<h6><span><span>&#8203;</span></span></h6>

				<h3><span>Anbieter im Sinne des TMG</span></h3>
				<p></p>

				<p>Die Zukunftsoptimisten UG (hb)<br>
				GS: Thomas-Mann-Straße 27 | 07743 Jena<br>
				HS: Marktplatz 9 | 34576 Homberg (Efze)<br>
				Tel.: +49(0)17683054861<br>
				E-Mail: <object height="0"><a class="auto-generated-link" data-auto-recognition="true" data-content="katrin@zukunftsoptimisten.de" href="mailto:katrin@zukunftsoptimisten.de" data-type="mail">katrin@zukunftsoptimisten.de</a></object>&nbsp;<br>
				<br>Plattform der EU-Kommission zur Online-Streitbeilegung:&nbsp;<span style="text-decoration:underline;"><a href="https://ec.europa.eu/odr" target="_blank" data-content="https://ec.europa.eu/odr" data-type="external" rel="noopener">https://ec.europa.eu/odr</a></span><br>
				Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht verpflichtet, hierzu jedoch grundsätzlich bereit.</p>
				<p><span>Autor und Verantwortlicher i.S.d. § 55 Abs. 2 RStV: Katrin Hitziggrad</span></p>

				<h3>Gestaltung & technische Umsetzung</h3>
				<p></p>
				<p>
					Tobias Hubold<br/>
					<a href="https://www.tobiashubold.de" target="_blank" rel="noopener noreferrer">https://www.tobiashubold.de</a>
				</p>
				<p></p>

				<h3>Bildquellen</h3>
				<p></p>
				<p>Martin Maleschka
				<br/>Katrin Hitziggrad
				<br/>Heidi Gumpert
				<br/>Jarno Müller
				<br/>Unsplash</p>
			</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>

</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
//import trans from '@/locale/trans'

export default {
  mixins: [layoutMixin],
  computed: {
  }
}
</script>

<style scoped>
a{
  overflow-wrap: break-word;
}
.containerText{
  max-width: 70%;
}
</style>
